/**
 * Représente un événement clic sur un noeud du menu contextuel.
 */
export class ContextMenuItemEvent {
    /**
     * Constructeur.
     * @param data : Donnée liée au noeud du menu contextuel.
     * @param source : Source du menu contextuel (Composant pour lequel le menu contextuel a été affiché).
     */
    constructor(
        public data: string,
        public source: string
    ) {}
}
